import { useApp } from "../context/AppContext";
import { Link, useLocation } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_deen-platform-8/artifacts/vfqdevan_ChatGPT%20Image%2022%20juin%202026%2C%2019_58_28.png";

export default function Header() {
  const { t, lang, setLang, langs } = useApp();
  const location = useLocation();

  return (
    <header className="nour-header sticky top-0 z-30 shadow-lg" data-testid="app-header">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-brand">
          <div className="w-12 h-12 rounded-2xl overflow-hidden shadow-md ring-1 ring-[#D4A14A]/30">
            <img src={LOGO} alt="tadekir logo" className="w-full h-full object-cover" />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-lg sm:text-xl tracking-tight lowercase">
              <span className="text-white">tadek</span><span className="text-[#F2C266]">i</span><span className="text-white">r</span>
            </div>
            <div className="text-[10px] sm:text-xs text-white/85 hidden sm:block">{t.tagline}</div>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          <select
            data-testid="language-select"
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            className="bg-white/15 backdrop-blur border border-white/25 rounded-full px-3 py-1.5 text-sm text-white outline-none cursor-pointer hover:bg-white/25 transition"
          >
            {langs.map(l => (
              <option key={l.code} value={l.code} className="text-nour-text">
                {l.flag} {l.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {location.pathname !== "/" && (
        <div className="max-w-5xl mx-auto px-4 pb-2 text-xs text-white/80 font-arabic-ui" dir="rtl" aria-hidden>
          ﷽
        </div>
      )}
    </header>
  );
}
